import { useBlockProps } from '@wordpress/block-editor';

export const Save = ({ attributes }) => {
    const { cards, styleType, carouselId } = attributes;
    const blockProps = useBlockProps.save();

    const classNames = {
        list: `${styleType}s-list`,
        card: `${styleType}-card`,
        imageWrap: `${styleType}-image-wrap`,
        image: `${styleType}-image`,
        title: `${styleType}-title`,
        content: `${styleType}-content`
    };

    const removeHtmlTags = (str) => {
        if (!str) return '';
        return str.replace(/<[^>]*>?/gm, '');
    };

    return (
        <div {...blockProps}>
            <div className="splide carousel-wrap" id={carouselId} data-configType={`${styleType}s-carousel`}>
                <div className="splide__track">
                    <ul className={`splide__list ${classNames.list}`} id={`${carouselId}_list`}>
                        {cards.map((card) => {
                            const link = card.card_link; // Assume 'card_link' è il nome del campo con il link
                            return (
                                <li key={card.id} className={`splide__slide ${classNames.card}`}>
                                    {link ? (
                                        <a href={link} target="_blank" className="slide-link">
                                            {styleType === 'traveltype' && (<div className="background-overlay black-overlay"></div>)}
                                            <figure className={`slide-image-wrap ${classNames.imageWrap}`}>
                                                {card.featured_media && (
                                                    <img
                                                        className={`slide-image ${classNames.image}`}
                                                        src={card._embedded['wp:featuredmedia'][0].source_url}
                                                        alt={card.title.rendered}
                                                    />
                                                )}
                                            </figure>
                                            {styleType !== 'review' ? (
                                                <h3 className={classNames.title}>{card.title.rendered}</h3>
                                            ) : (
                                                <div className="review-content">
                                                    <h3 className="review-title">{card.title.rendered}</h3>
                                                    <p>{removeHtmlTags(card.content.rendered)}</p>
                                                </div>
                                            )}
                                        </a>
                                    ) : (
                                        <>
                                            {styleType === 'traveltype' && (<div className="background-overlay black-overlay"></div>)}
                                            <figure className={`slide-image-wrap ${classNames.imageWrap}`}>
                                                {card.featured_media && (
                                                    <img
                                                        className={`slide-image ${classNames.image}`}
                                                        src={card._embedded['wp:featuredmedia'][0].source_url}
                                                        alt={card.title.rendered}
                                                    />
                                                )}
                                            </figure>
                                            {styleType !== 'review' ? (
                                                <h3 className={classNames.title}>{card.title.rendered}</h3>
                                            ) : (
                                                <div className="review-content">
                                                    <h3 className="review-title">{card.title.rendered}</h3>
                                                    <p>{removeHtmlTags(card.content.rendered)}</p>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
};
